import "core-js/modules/es6.function.name";
import TeamtreeAndCarComponent from "./index.vue";
var TeamtreeCar = {
  install: function install(Vue) {
    Vue.component(TeamtreeAndCarComponent.name, TeamtreeAndCarComponent);
  },
  key: TeamtreeAndCarComponent.name
};
export default TeamtreeCar;